export default "__VITE_ASSET__czQslNt9__"